<template>
  <div class="tab-bd pt30 enroll">
    <!-- <div class="boxfile fl pr">
      <div class="fileupload posr">
        <img :src="src" alt="" style="width: 120px;height: 160px;" :onerror="errImg">
        <input type="file" name="file" class="fiedbox" id='file' @change="uploadImg"
               accept='image/*'>
      </div>
      <label for="file" class="posa label">上传照片</label>
    </div> 
    -->
    <div class="enrollList formright">
      <div class="item">
        <label>姓名</label>
        <div class="fl form_right">
          <Input v-model="data.xm" style="width:330px" disabled/>
        </div>
      </div>
      <div class="item">
        <label>身份证号码</label>
        <div class="fl form_right">
          <Input v-model="data.sfzjh" style="width:330px" disabled/>
        </div>
      </div>
      <div class="item">
        <label>性别</label>
        <div class="fl form_right pr">
          <div class="ha_selbox">
            <Select style="width:330px;text-align:left;" v-model="data.xbm" v-if="data.xbm" disabled>
              <Option v-for="(key,value) in dict.xbm" :value="value" :key="value">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="item">
        <label>批次</label>
        <div class="fl form_right pr">
          <div class="ha_selbox">
            <Select style="width:330px;text-align:left;" v-model="data.batch_id" v-if="data.batch_id" disabled>
              <Option v-for="(key,value) in dict.batch" :value="value" :key="value">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="item">
        <label>考生号</label>
        <div class="fl form_right">
          <Input  v-model="data.kh" style="width:330px" disabled />
        </div>
      </div>
        <div class="item">
        <label>考试类型</label>
        <div class="fl form_right">
          <Input :value="xzm"  style="width:330px" disabled/>
        </div>
      </div>

       <div class="item" >
        <label>手机号</label>
        <div class="fl form_right">
          <input type="text" v-model="data.mobile"
                 placeholder="请输入手机号"
                 @blur="chenkNum"
                 :class="{red:isRed}"
                 class="input_field"
                 style="width:330px">
         </div>
      </div>
       <div class="item">
        <label>邮政编码</label>
        <div class="fl form_right">
          <input type="text" v-model="data.postal_code" class="input_field" style="width: 330px;">
        </div>
      </div>

      <div class="item">
        <label>收件人</label>
        <div class="fl form_right">
          <input type="text" v-model="data.sjr" class="input_field" style="width:330px;">
        </div>
      </div>
      <div class="item">
        <label>通信地址</label>
        <div class="fl form_right">
          <textarea type="text" maxlength="100" name="rsNodeName" v-model="data.txdz"
                 id="rsNodeName" placeholder="请输入通信地址"
                 class="input_field"
                 style="width:330px;padding:5px;min-height:55px;">
          </textarea>
        </div>
      </div>
     
      <!-- <div class="quertion item">
          <label>是否参加校考<b class="star none">*</b></label>
          <div class="fl form_right">
            <span>是</span>
              <input type="radio" class="radio" style="width:18px;height:18px" name='1' value="7" v-model="data.state">
            <span>否</span>
              <input type="radio" class="radio"  style="width:18px;height:18px" name='1' value="6" v-model="data.state">
          </div>
       </div> -->
      <!-- <div class="item">
        <label>出生日期<b class="star"></b></label>
        <div class="fl form_right">
          <Input v-model="data.csrq" style="width:330px" disabled/>
        </div>
      </div>
     <div class="item">
        <label>民族<b class="star"></b></label>
        <div class="fl form_right pr">
          <div class="ha_selbox fl">
            <Select style="width:330px" v-model="data.mzm" disabled>
              <Option v-for="(key,value) in dict.mzm" :value="value" :key="value">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div>
       <div class="item">
        <label>籍贯<b class="star"></b></label>
        <div class="fl form_right pr">
          <div class="ha_selbox">
            <Select style="width:330px" v-model="jgm" @on-change="jg" disabled>
              <Option v-for="(key,value) in dict.jg" :value="value" :key="value">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div> -->  
    
      <!-- <div class="item">
        <label>政治面貌<b class="star none">*</b></label>
        <div class="fl form_right pr">
          <div class="ha_selbox">
            <Select style="width:330px" v-model="data.zzmmm" disabled>
              <Option v-for="(key,value) in dict.zzmmm" :value="value" :key="value">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="item">
        <label>来源地区<b class="star"></b></label>
        <div class="fl form_right">
          <select
            class=" my_select"
            v-model="data.provinceCode"
            @change="getCity(data.provinceCode,0)"
          >
          <option v-for="(item,index) in provinceList" :key="index" :value="item.area_code">{{item.area_name}}</option>
          </select>
          <select
            class="my_select"
            v-model="data.cityCode"
            @change="getArea(data.cityCode)"
          >
          <option v-for="(item,index) in cityList" :key="index" :value="item.area_code">{{item.area_name}}</option>
          </select>
        </div>
      </div>
        <div class="item">
         <label>生源所在地<b class="star"></b></label>
         <div class="col-sm-7">
           <select class="my_selectone" v-model="data.lydqdm">
            <option v-for="(item,index) in areaList" :key="index" :value="item.area_code">{{item.area_name}}</option>
          </select>
        </div>
        </div>
      -->

    </div>
    <div class="formbutton"><a href="javascript:;" class="btn" @click="modal1 = true">提交</a></div>
   
    <Modal
      v-model="modal1"
      title="系统提示"
      @on-ok="ok"
      @on-cancel="cancel">
      <p>确定要提交吗？</p>
    </Modal>
     <tip :tip="tip" v-if="tipShow"></tip>
    <page-load v-if="loading"></page-load>
  </div>
</template>

<script>
import { uploadImg, finishPersonInfo, personal, area } from "../api/updata";
import config from "../api/config";
import pageLoad from "../pageload/pageload";
export default {
  components: { pageLoad },
  data() {
    return {
      loading: true,
      modal1: false,
      data: {},
      state: "",
      dict: {}, //保存数据和字典
      tip: "",
      tipShow: false,
      isRed: false,
      xzm: "", //考试类型
      jgm: 0, //籍贯码
      dis: false,
      list: [{ value: 6 }, { value: 7 }]
      // mzm: 1,  //名族码
      // src: "", //图片src绑定
      // errImg: 'this.src="' + require("../assets/images/moren.png") + '"', //默认图片
      // resource_id: "", //图片绑定id
      // jgm: 0, //籍贯码
      // provinceList: [],
      // cityList: [],
      // areaList: {},
      // provinceCode: "",
      // cityCode: "",
      // chackname: "",
      // single: false,
      // single2: false,
    };
  },
  created() {
    this._personal(); //首次获取信息接口
  },

  methods: {
    // 获取身份证号和性别
    getInfo() {
      let that = this;
      let sfzjh = JSON.parse(
        this.global.Base64.decode(sessionStorage.getItem("INFO"))
      ).sfzjh;
      this.loading = false;
      setTimeout(() => {
        //出生日期
        this.data.csrq =
          sfzjh.substring(6, 10) +
          "-" +
          sfzjh.substring(10, 12) +
          "-" +
          sfzjh.substring(12, 14);
        if (parseInt(sfzjh.substring(16, 17)) % 2 == 1) {
          //男
          that.data.xbm = "1";
          //女
        } else if (parseInt(sfzjh.substring(16, 17)) % 2 == 0) {
          that.data.xbm = "2";
        } else {
          that.data.xbm = "9";
        }
      }, 1000);
    },
    //首次获取信息接口
    _personal() {
      let module = {
        sfzjh: this.global.Base64.encode(
          JSON.parse(Base64.decode(sessionStorage.getItem("INFO"))).sfzjh
        ),
        xm: JSON.parse(
          this.global.Base64.decode(sessionStorage.getItem("INFO"))
        ).xm,
        batch_id: JSON.parse(
          this.global.Base64.decode(sessionStorage.getItem("INFO"))
        ).batch_id
      };
      let that = this;
      this.loading = true;
      personal(module)
        .then(res => {
          if (res.status) {
            this.data = res[0].data;
            if (this.data.xzm == 1) {
              this.xzm = "笔试（普通高中）";
            } else if (this.data.xzm == 2) {
              this.xzm = "面试（中职）";
            }
            this.dict = res[0].dict;
            this.getInfo();
            //this.getProvice();获取省
            // this.mzm = par seInt(res[0].data.mzm);
            // 籍贯的匹配
            // for (let key in that.data) {
            //   if (key == "jg") {
            //     for (let key1 in that.dict.jg) {
            //       if (that.data[key] == that.dict.jg[key1]) {
            //         that.jgm = key1;
            //       }
            //     }
            //   }
            // }
            // 返回图片路径
            // this.src =
            //   config.url +
            //   res[0].data.head_img[0].save_path +
            //   res[0].data.head_img[0].save_name;
          } else {
            this.tipCtr("请稍候再试");
            this.loading = false;
          }
        })
        .catch(() => {
          this.tipCtr("未找到相关数据,请重新加载");
          this.loading = false;
        });
    },
    //更新个人信息
    finishInfo() {
      this.loading = true;
      if (this.chenkNum()) {
        let module = {
          sfzjh: Base64.encode(this.data.sfzjh), //身份证号
          xm: this.data.xm, //姓名
          batch_id: this.data.batch_id, //批次
          xbm: this.data.xbm, //性别
          kh: this.data.kh, //考生号
          xzm: this.data.xzm, // 考试类型
          mobile: this.data.mobile, //手机号
          txdz: this.data.txdz, //通信地址
          csrq: this.data.csrq, //出生日期
          postal_code: this.data.postal_code, //邮政编码
          sjr: this.data.sjr //收件人
          // jg: this.data.jg, //籍贯
          // zzmmm: this.data.zzmmm, //政治面貌
          // lydqdm: this.data.lydqdm, //生源地
          // mzm: this.data.mzm, //民族
          // resource_id: this.resource_id,//图片id
          // state: this.data.state, //是否参加校考
          // provinceCode: this.data.provinceCode, //行政区划 省
          // cityCode: this.data.cityCode//行政区划 市
        };
        finishPersonInfo(module)
          .then(res => {
            this.loading = false;
            if (res.status) {
              this.tipCtr(res.msg);
            } else {
              this.tipCtr(res.msg);
            }
          })
          .catch(() => {
            this.tipCtr("未找到相关数据,请重新加载");
            this.loading = false;
          });
      } else {
        this.chenkNum();
      }
    },
    chenkNum() {
      this.loading = false;
      let reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
      //判断手机号是否存在
      if (!this.data.mobile) {
        this.isRed = true;
        this.tipCtr("请输入手机号");
        return false;
      } else if (!reg.test(this.data.mobile)) {
        this.isRed = true;
        this.tipCtr("请输入正确的手机号");
        return false;
      } else {
        this.isRed = false;
        return true;
      }
    },
    //tip控制方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    },
    // 提示框  确定按钮
    ok() {
      this.finishInfo();
    },
    // 提示框取消按钮
    cancel() {
      this.modal1 = false;
    }

    // 籍贯匹配,发送匹配
    // jg(val) {
    //   for (let key in this.dict.jg) {
    //     if (val == key) {
    //       this.data.jg = this.dict.jg[key];
    //     }
    //   }
    // },
    // 点击图片上传事件
    // uploadImg(event) {
    //   let that = this;
    //   let files = event.target.files[0];
    //   let formData = new FormData();
    //   formData.append("file", files);
    //   that.file = formData;

    //   // 图片渲染
    //   let reader = new FileReader();
    //   reader.readAsDataURL(files);
    //   reader.onloadend = function() {
    //     that.src = this.result; //base64
    //     that._uploadImg();
    //   };
    // },
    // 图片上传接口
    // _uploadImg() {
    //   let module = {
    //     file: this.file
    //   };
    //   uploadImg(module)
    //     .then(res => {
    //       if (res.status) {
    //         this.resource_id = res.data.resource_id;
    //         setTimeout(() => {
    //           this.finishInfo();
    //         }, 1500);
    //         this.tipCtr(res.msg);
    //       } else {
    //         this.tipCtr(res.msg);
    //       }
    //     })
    //     .catch(() => {
    //       this.tipCtr("未找到相关数据,请重新加载");
    //     });
    // },
    //获取省
    // getProvice() {
    //   let module = {
    //     area_code: "000000"
    //   };
    //   this.loading = true;
    //   area(module)
    //     .then(res => {
    //       if (res.status && res.data && res.data.length > 0) {
    //         this.provinceList = res.data;
    //         if (this.data.provinceCode != "") {
    //           this.getCity(this.data.provinceCode, 1);
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       this.tipCtr("未找到相关数据,请重新加载");
    //     });
    // },
    //获取市
    // getCity(code, tag) {
    //   if (code == "") {
    //     return false;
    //   }
    //   this.cityList = [];
    //   this.areaList = [];
    //   if (tag == 0) {
    //     this.data.cityCode = "";
    //     this.data.area_code = "";
    //   }
    //   let module = {
    //     area_code: code
    //   };
    //   area(module)
    //     .then(res => {
    //       if (res.status && res.data && res.data.length > 0) {
    //         this.cityList = res.data;
    //         this.getArea(this.data.cityCode);
    //       }
    //     })
    //     .catch(err => {
    //       this.tipCtr("未找到相关数据,请重新加载");
    //     });
    // },
    //获取区
    // getArea(code) {
    //   if (code == "") {
    //     return false;
    //   }

    //   let module = {
    //     area_code: code
    //   };

    //   area(module)
    //     .then(res => {
    //       this.loading = false;
    //       if (res.status && res.data && res.data.length > 0) {
    //         this.areaList = res.data;
    //       } else {
    //         this.tipCtr("暂无数据");
    //       }
    //     })
    //     .catch(err => {
    //       this.loading = false;
    //       this.tipCtr("未找到相关数据,请重新加载");
    //     });
    // },
  }
};
</script>

<style scoped>
.item {
  color: #333;
}
.label {
  bottom: -44px;
  left: 30px;
  cursor: pointer;
  font-size: 16px;
}

input.red {
  border: 1px solid red;
}

.none {
  color: #fff !important;
}
.radio {
  padding-bottom: 20px;
  margin: 0 10px;
}
.quertion {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
}
.my_select {
  width: 200px !important;
  height: 30px;
  border-radius: 4px;
  display: inline-block;
}
.my_selectone {
  width: 200px !important;
  height: 30px;
  border-radius: 4px;
  display: inline-block;
}
.fileupload {
  box-shadow: 2px 0px 8px 0px rgba(224, 224, 224, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/personalInfo.vue